import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { cancelMyReturn } from '../../api/apiReturns';
import parseError from '../../utils/parseError';

export const useCancelMyReturn = () => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, reason }) => cancelMyReturn(id, reason ? { reason } : {}),
        onSuccess: (_, vars) => {
            toast.success(t('returns.cancelled', 'Return cancelled'));
            queryClient.invalidateQueries({ queryKey: ['my-return', vars.id] });
            queryClient.invalidateQueries({ queryKey: ['my-returns'] });
        },
        onError: (err) => {
            toast.error(parseError(err) || t('returns.cancelError', 'Could not cancel return'));
        },
    });
};

export default useCancelMyReturn;
